module.exports = __webpack_public_path__ + "preview.5db238dd036b942e04d610d9f591bf12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview.png
// module id = 462
// module chunks = 0